import { Box, Button } from "@mui/material";

import NotificationCardWrapper from "../NotificationCardWrapper";
import profile1 from "../../../../media/svg/Avatar/Avatar.svg";
import DiscussionThumbnail from "../../../../media/svg/DiscussionThumbnail.png";

const NotificationInvitation = () => {
  return (
    <NotificationCardWrapper
      firstChild={
        <img
          width='48px'
          height='48px'
          style={{ borderRadius: "50%", border: "solid 2px black" }}
          src={profile1}
          alt='profilePicture'
        />
      }
      seccondChild={
        <Box style={{ fontWeight: "600" }}>
          Anna invited you to Who will win the market?
        </Box>
      }
      ThirdChild={
        <img
          width='48px'
          height='48px'
          style={{ borderRadius: "8px", border: "solid 2px black" }}
          src={DiscussionThumbnail}
          alt='profilePicture'
        />
      }
      firstButton={
        <Button
          variant='contained'
          size='small'
          sx={{
            backgroundColor: "#FAFAFA",
            border: "2px solid",
            borderColor: "black.main",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "600",
            alignItems: "center",
            height: "32px",
            paddingY: "7px",
            paddingTop: "10px",
            "&.MuiButtonBase-root:hover": {
              border: "2px solid",
              backgroundColor: "primary.main",
              boxShadow: ` 0px 2px 0px black`,
            },
            "&.MuiButtonBase-root:active": {
              backgroundColor: "black.main",
              color: "white.main",
              boxShadow: "none",
            },
          }}
          fullWidth
        >
          Reject
        </Button>
      }
      seccondButton={
        <Button
          variant='contained'
          color='primary'
          size='small'
          sx={{
            border: "2px solid",
            borderColor: "black.main",
            boxShadow: ` 0px 2px 0px black`,
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: "600",
            alignItems: "center",
            height: "32px",
            paddingY: "7px",
            paddingTop: "10px",
            "&.MuiButtonBase-root:hover": {
              border: "2px solid",
              backgroundColor: "primary.main",
              boxShadow: ` 0px 2px 0px black`,
            },
            "&.MuiButtonBase-root:active": {
              backgroundColor: "black.main",
              color: "white.main",
              boxShadow: "none",
            },
          }}
          fullWidth
        >
          Accept
        </Button>
      }
    />
  );
};

export default NotificationInvitation;
